module.exports = __webpack_public_path__ + "static/img/bg.844b7d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpg
// module id = 254
// module chunks = 0 1 2 3 4 5 6 7 8 9